import { render } from "./pagos.vue?vue&type=template&id=4e98015a"
import script from "./pagos.vue?vue&type=script&lang=js"
export * from "./pagos.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__